import React, { useEffect, useState } from "react";
import { Form, Row, Col, Tabs, Tab, Button } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import MaleForm from "./MaleForm";
import Female_Details from "./Female_Details";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// import { useSample } from "../context/SampleContext";

function Male_Details() {
    const sampleCode = useSelector((state) => state.sample.code);
    const [center_list, setCenter_list] = useState([]);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("male");
    const [maleSaved, setMaleSaved] = useState(false);

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmittingFemale, setIsSubmittingFemale] = useState(false);


    console.log(sampleCode);
    const { user: loggedUser } = useAuth();

    const [maleForm, setMaleForm] = useState({
        CRN_No: "",
        Patient_Name: "",
        sample_id: "",
        Age: "",
        dob: "",

        Education: "",
        Occupation: "",
        Smoking: "1",
        Chewing_Tobacco: "1",
        Alcohol: "1",
        Diabetes: "0",
        Hypertension: "0",
        Genetic_Conditions: "",
        Mumps: "0",
        Trauma: "0",
        Surgeries: "0",
        Hernia: "0",
        Undescended_Testes: "0",
        Varicocele: "0",
        Vasectomy: "0",
        STD_Genital_Discharges: "0",
        Others: "",
        General_Examination: "",
        Local_Examination: "",
        Blood_Group: "",
        Blood_Sugar_R: "",
        HIV: "0",
        HBsAg: "0",
        Hb_Electrophoresis: "0",
        USG_Doppler: "",
        Karyotyping_Analysis: "",
        Testicular_Biopsy: "",
        Urologist_Opinion: "",
        Others_any: "",
        Date_of_Sample: "",
        Ejaculatory_Abstinence: "",
        Semen_Volume: "",
        Color: "",
        Appearance: "",
        Liquifcation_Time: "",
        Viscosity: "",
        pH: "",
        Semen_Concentration: "",
        Total_Sperm_Count: "",
        Progressive_Motility_Rate: "",
        Count_Motile_Sperm: "",
        NonP_Motility: "",
        Total_Motility: "",
        Total_NP_Motile_Sperm: "",
        Vitality: "",
        Normal_Sperm_Morphology: "",
        Abnormal_Heads: "",
        Abnormal_NandM: "",
        Abnormal_Tail: "",
        Extra_cytoplasmic: "",
        Qualitative_Fructose: "",
        Aggregation: "",
        Agglutination: "",
        Round_Cells: "",
        Epithelial_Cells: "",
        Other_Cells: "",
        Other_Remarks: "",
        center_code: "",
        procedure: "",
        cycle: "",
        donor_sperm: "",
        serial_no: "",
        sample_generated: "",

        execfile_dysfunction: "0",
        pre_mature_ejaculation: "0",

        Blood_Sugar_F: "",
        Blood_Sugar_PP: "",
        Semen_Concentration_unit: "",
        Progressive_Motility_unit: "",

        Liquifcation_Remark: "",
        Hb_Remark: "",
        ag_Remark: "",
        RSA_Report: "",
        Diabetes_Type: "",
        Diabetes_Duration: "",
        Hypertension_Duration: "",

        Immotile: "",

        ALT: "",
        ALP: "",
        AST: "",
        AST_ALT: "",
        GTT: "",
        Total_Bilirubin: "",
        Direct_Bilirubin: "",
        Indirect_Bilirubin: "",
        Total_Plastma_Protein: "",
        Albumin: "",
        Globulin: "",
        Albumin_Globulin_Ratio: "",
        Liver_Test_remark: "",

        Total_Cholesterol: "",
        LDL_Cholesterol: "",
        HDL_Cholesterol: "",
        VLDL_Cholesterol: "",
        Triglycerides: "",
        Total_cholesterol_HDL_ratio: "",
        LDL_to_HDL_ratio: "",
        Non_HDL_cholesterol: "",
        Lipid_Profile_remark: "",

        Total_Body_Water: "",
        Protein: "",
        Minerals: "",
        Body_Fat_Mass: "",
        Soft_Lean_Mass: "",
        Fat_Free_Mass: "",
        Body_Weight: "",
        Height: "",
        Body_Composition_remark: "",

        Weight: "",
        Skeletal_Muscle_Mass: "",
        Body_Fat_Mass_muscle: "",
        Body_Fat_Percent: "",
        Body_muscle_remark: "",

        BMI_Obesity: "",
        Percent_Body_Fat: "",
        obesity_remark: "",

        Right_Arm_Lean_Mass_kg: "",
        Right_Arm_Lean_Mass_percent: "",
        Right_Arm_ECW_Ratio: "",
        Left_Arm_Lean_Mass_kg: "",
        Left_Arm_Lean_Mass_percent: "",

        Left_Arm_ECW_Ratio: "",
        Trunk_Lean_Mass_kg: "",
        Trunk_Lean_Mass_percent: "",
        Trunk_ECW_Ratio: "",
        Right_Leg_Lean_Mass_kg: "",
        Right_Leg_Lean_Mass_percent: "",
        Right_Leg_ECW_Ratio: "",
        Left_Leg_Lean_Mass_kg: "",
        Left_Leg_Lean_Mass_percent: "",
        Left_Leg_ECW_Ratio: "",
        Segmental_remark: "",

        Right_Arm_Fat_Mass_kg: "",
        Right_Arm_Fat_Mass_percent: "",
        Left_Arm_Fat_Mass_kg: "",
        Left_Arm_Fat_Mass_percent: "",
        Trunk_Fat_Mass_kg: "",
        Trunk_Fat_Mass_percent: "",
        Right_Leg_Fat_Mass_kg: "",
        Right_Leg_Fat_Mass_percent: "",
        Left_Leg_Fat_Mass_kg: "",
        Left_Leg_Fat_Mass_percent: "",
        Segmental_fat_remark: "",


        Semen_Concentration_post: "",
        Total_Sperm_Count_post: "",
        Progressive_Motility_Rate_post: "",
        NonP_Motility_post: "",
        Immotile_post: "",
        Total_Motility_post: "",
        Normal_Sperm_Morphology_post: "",
        Abnormal_Heads_post: "",
        Abnormal_NandM_post: "",
        Abnormal_Tail_post: "",
        Extra_cytoplasmic_post: ""




    });
    const [femaleForm, setFemaleForm] = useState({

        CRN_No: "",
        Patient_Name: "",
        sample_id: "",
        Infertility_Reg_no: "",
        Age: "",
        dob: "",
        reg_date: "",
        address: "",
        Education: "",
        Occupation: "",
        refrred_by: "",
        Drug_Allergy: "",

        Married_Since: "",
        Infertility_Duration: "",
        Primary_Infertility: "",
        Secondary_Infertility: "",
        Other_Remarks: "",

        Age_at_Menarche: "",
        Day_of_MC: "",
        Previous_Cycle: "",
        Last_MC: "",
        Menstrual_Loss: "",
        Dysmenorrhea: "0",
        Postcoital_Bleeding: "0",
        Intermenstrual_Bleeding: "0",
        Menstural_Remarks: "",

        Intercourse_type: "",
        Intercourse_Frequency: "",
        Dyspareunia: "0",
        Erectile_Dysfunction: "0",
        Premature_Ejaculation: "0",
        Sexual_Remarks: "",

        Hirsutism: "0",
        Acanthosis_Nigricans: "0",
        Galactorrhoea: "0",
        Rubella_Vaccination: "0",
        Consanguineous_Marriage: "0",
        Contraceptive_Method: "",
        History_Remarks: "",

        Hypertension: "0",
        Medication_Hypertension: "",
        Diabetes: "0",
        Medication_Diabetes: "",
        Thyroid: "0",
        Medication_Thyroid: "",
        Cardiac_Disease: "0",
        Drugs_Cardiac_Disease: "",
        Medication_Cardiac_Disease: "",
        Medical_Remarks: "",

        Surgical_History: "",
        Family_History: "",

        Ovulation_Induction_Drugs: "",
        IUI: "",
        Prior_IVF: "",
        Treatment_Remarks: "",

        Height: "",
        Weight: "",
        BMI: "",
        Waist_Hip_Ratio: "",
        Blood_Pressure: "",
        Respiratory_System_Examination: "",
        CVS_Examination: "",
        Breast_Examination: "",
        Local_Examination: "",
        Per_Abdomen_Exam: "",
        Per_Speculum_Exam: "",
        Per_Vaginal_Exam: "",

        Blood_Group: "",
        CBC: "",
        Blood_Sugar_R: "",

        HbA1C: "",
        Hb_Electrophoresis: "",
        TORCH: "",
        Thrombophilia_Profile: "",
        Cervical_Smear: "",
        Karyotyping: "",
        Karyotyping_Wife: "",
        HIV: "0",
        HCV: "0",
        HBsAg: "0",
        HSG: "",



        female_Remark: "",
        Blood_Pressure_DBP: "",
        VDRL_Aldo: "",
        Obstetric_History: "",
        investigation_remark: "",

        Mid_cycle_Endometrial_Thickness: "",
        Ultrasound_Findings: "",
        Hystero_laparoscopy_Findings: ""


    });


    const today = new Date().toISOString().split("T")[0];
    const [maleHormonalRows, setMaleHormonalRows] = useState([
        {
            assay_date: today,
            FSH: "",
            LH: "",
            Testosterone: "",
            Prolactin: "",
            FT4: "",
            FT3: "",
            TSH: ""
        }
    ]);

    const [femaleHormonalRows, setFemaleHormonalRows] = useState([
        {
            // assay_date: today,
            // AMH: "",
            // TSH: "",
            // Prolactin: "",
            AMH: "",
            FSH: "",
            LH: "",
            Estradiol: "",
            Progesterone: "",
            TSH: "",
            Prolactin: "",
        }
    ]);



    // const handleFormChange = (section, e) => {
    //     const { name, value } = e.target;
    //     let updatedValue = value;

    //     if (name === "serial_no") {
    //         const numeric = value.replace(/\D/g, "");

    //         if (!numeric) {
    //             updatedValue = "";
    //         } else {
    //             const numberValue = parseInt(numeric, 10);

    //             if (numberValue > 999) {
    //                 updatedValue = "";
    //             } else {
    //                 updatedValue = numberValue < 100 ? String(numberValue).padStart(3, "0") : String(numberValue);
    //             }
    //         }
    //     }

    //     setForm((prev) => ({
    //         ...prev,
    //         [section]: {
    //             ...prev[section],
    //             [name]: updatedValue,
    //         },
    //     }));
    // };

    const handleMaleChange = (e) => {
        const { name, value, type } = e.target;


        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }

        let updatedValue = value;
        if (name === "serial_no") {
            const numeric = value.replace(/\D/g, "");

            if (!numeric) {
                updatedValue = "";
            } else {
                const numberValue = parseInt(numeric, 10);

                if (numberValue > 999) {
                    updatedValue = "";
                } else {
                    updatedValue = numberValue < 100 ? String(numberValue).padStart(3, "0") : String(numberValue);
                }
            }
        }

        setMaleForm(prev => ({
            ...prev,
            // [name]: value,
            [name]: updatedValue,
        }));
    };

    // For Female_Details
    const handleFemaleChange = (e) => {
        const { name, value, type } = e.target;


        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }
        setFemaleForm(prev => ({
            ...prev,
            [name]: value
        }));
    };





    useEffect(() => {
        if (loggedUser?.role !== "1") return;

        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${API_URL}/get_center_list`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setCenter_list(res.data.center_list || []);
                console.log("Center List:", res.data.center_list);
            })
            .catch((err) => {
                console.error("Center list error:", err);
            });
    }, [loggedUser]);



    useEffect(() => {
        if (!loggedUser) return;

        if (loggedUser.role !== "1") {
            setMaleForm(prev => ({
                ...prev,
                center_code: `${loggedUser.center_code}/PIWIL`
            }));
        }
    }, [loggedUser]);

    useEffect(() => {
        if (loggedUser) {
            setMaleForm(prev => ({
                ...prev,
                center_code: `${loggedUser.center_code}/PIWIL`
            }));
        }
    }, [loggedUser]);


    useEffect(() => {
        if (!loggedUser) return;

        if (loggedUser.role !== "1") {
            setFemaleForm(prev => ({
                ...prev,
                center_code: `${loggedUser.center_code}/PIWIL`
            }));
        }
    }, [loggedUser]);

    useEffect(() => {
        if (loggedUser) {
            setFemaleForm(prev => ({
                ...prev,
                center_code: `${loggedUser.center_code}/PIWIL`
            }));
        }
    }, [loggedUser]);

    const [isMaleAgeManual, setIsMaleAgeManual] = useState(false);
    const [isFemaleAgeManual, setIsFemaleAgeManual] = useState(false);
    const handleMaleDobChange = (dob) => {
        let age = "";

        if (dob) {
            const birthDate = new Date(dob);
            const today = new Date();
            age = today.getFullYear() - birthDate.getFullYear();

            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
        }
        setIsMaleAgeManual(false);
        setMaleForm(prev => ({
            ...prev,
            dob,
            Age: age
        }));
    };


    const handleMaleAgeChange = (e) => {
        setIsMaleAgeManual(true);

        const { name, value, type } = e.target;


        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }

        setMaleForm(prev => ({
            ...prev,
            Age: e.target.value
        }));
    };


    const handleFemaleAgeChange = (e) => {
        setIsFemaleAgeManual(true);

        const { name, value, type } = e.target;

        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }

        setFemaleForm(prev => ({
            ...prev,
            Age: e.target.value
        }));
    }

    const handleFemaleDobChange = (dob) => {


        let age = "";

        if (dob) {
            const birthDate = new Date(dob);
            const today = new Date();
            age = today.getFullYear() - birthDate.getFullYear();

            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
        }
        setIsFemaleAgeManual(false);
        setFemaleForm(prev => ({
            ...prev,
            dob,
            Age: age
        }));
    };

    // const handleMaleCalculationChange = (e) => {
    //     const { name, value } = e.target;

    //     setMaleForm(prev => {
    //         // Step 1: update changed field
    //         const updatedForm = {
    //             ...prev,
    //             [name]: value
    //         };

    //         // Step 2: calculate safely
    //         const volume = parseFloat(updatedForm.Semen_Volume) || 0;
    //         const concentration = parseFloat(updatedForm.Semen_Concentration) || 0;

    //         updatedForm.Total_Sperm_Count =
    //             volume > 0 && concentration > 0
    //                 ? (volume * concentration).toFixed(2)
    //                 : "";

    //         return updatedForm;
    //     });
    // };

    // const handleMotility = (e) => {
    //     const { name, value } = e.target;

    //     setMaleForm(prev => {
    //         const updatedForm = {
    //             ...prev,
    //             [name]: value
    //         };

    //         // const pr = parseFloat(updatedForm.Count_Motile_Sperm) || 0;
    //         const pr = parseFloat(updatedForm.Progressive_Motility_Rate) || 0;

    //         const np = parseFloat(updatedForm.NonP_Motility) || 0;
    //         // const Immotile = parseFloat(updatedForm.Immotile) || 0;

    //         updatedForm.Total_Motility =
    //             pr > 0 || np > 0 ? (pr + np).toFixed(2) : "";

    //         return updatedForm;
    //     });
    // };

    // const handleProgressiveMotileSperm = (e) => {
    //     const { name, value } = e.target;

    //     setMaleForm(prev => {
    //         const updatedForm = {
    //             ...prev,
    //             [name]: value
    //         };

    //         const motilityRate =
    //             parseFloat(updatedForm.Progressive_Motility_Rate) || 0;

    //         const totalSpermCount =
    //             parseFloat(updatedForm.Total_Sperm_Count) || 0;

    //         updatedForm.Count_Motile_Sperm =
    //             motilityRate > 0 && totalSpermCount > 0
    //                 ? ((motilityRate / 100) * totalSpermCount).toFixed(2)
    //                 : "";

    //         return updatedForm;
    //     });
    // };




    useEffect(() => {
        const {
            center_code,
            procedure,
            serial_no,
            donor_sperm,
            cycle
        } = maleForm;

        const donorValue = donor_sperm === "N" ? "" : donor_sperm;

        if (center_code && procedure && serial_no && cycle) {
            const parts = [
                center_code,
                procedure,
                cycle,
                donorValue,
                serial_no
            ].filter(Boolean);

            const generated = parts.join("/");

            // update MALE
            setMaleForm(prev => ({
                ...prev,
                sample_generated: generated,
                sample_id: generated
            }));

            // update FEMALE (only what is needed)
            setFemaleForm(prev => ({
                ...prev,
                sample_id: generated
            }));
        }
    }, [
        maleForm.center_code,
        maleForm.procedure,
        maleForm.serial_no,
        maleForm.donor_sperm,
        maleForm.cycle
    ]);

    /////////////////////////////////////////////start validations//////////////////
    const [sampleValid, setSampleValid] = useState(false);
    const [crnDisabled, setCrnDisabled] = useState(true);
    const [sampleError, setSampleError] = useState("");


    // useEffect(() => {
    //     setSampleValid(false);
    //     setCrnDisabled(true);
    //     setSampleError("");
    // }, [
    //     form.male.center_code,
    //     form.male.procedure,
    //     form.male.cycle,
    //     form.male.serial_no,
    //     form.male.donor_sperm
    // ]);


    const validateBeforeMove = async () => {
        const sampleId = maleForm.sample_generated?.trim();

        if (!sampleId) {
            setSampleValid(false);
            setCrnDisabled(true);
            setSampleError("");
            return;
        }

        try {
            const token = localStorage.getItem("token");
            if (!token) return;

            const res = await axios.get(`${API_URL}/get_sample_code`, {
                params: { code: sampleId },
                headers: { Authorization: `Bearer ${token}` },
            });

            if (res.data.status && res.data.sample_code) {
                setSampleValid(false);
                setCrnDisabled(true);
                setSampleError("Sample ID already exists!");
            } else {
                setSampleValid(true);
                setCrnDisabled(false);
                setSampleError("");
            }
        } catch (err) {
            setSampleValid(false);
            setCrnDisabled(true);
            setSampleError("Server error!");
        }
    };


    ////////////////////////////////////////////////////////////
    const check_serial_number = async (centerCode) => {
        if (!centerCode) return;

        try {
            const token = localStorage.getItem("token");
            if (!token) return;

            const res = await axios.get(
                `${API_URL}/get_serial_number`,
                {
                    params: { center_code: centerCode },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (res.data?.suggested_serial) {
                setMaleForm(prev => ({
                    ...prev,
                    serial_no: res.data.suggested_serial
                }));
            }

        } catch (error) {
            console.error("Serial number error:", error);
        }
    };



    ///////////////////////////////////////////////////end validations///////////////
    function toRoman(num) {
        const romanMap = [
            { value: 1000, numeral: "M" },
            { value: 900, numeral: "CM" },
            { value: 500, numeral: "D" },
            { value: 400, numeral: "CD" },
            { value: 100, numeral: "C" },
            { value: 90, numeral: "XC" },
            { value: 50, numeral: "L" },
            { value: 40, numeral: "XL" },
            { value: 10, numeral: "X" },
            { value: 9, numeral: "IX" },
            { value: 5, numeral: "V" },
            { value: 4, numeral: "IV" },
            { value: 1, numeral: "I" }
        ];

        let result = "";
        for (const { value, numeral } of romanMap) {
            while (num >= value) {
                result += numeral;
                num -= value;
            }
        }
        return result;
    }
    const romanNumbers = Array.from({ length: 50 }, (_, i) => toRoman(i + 1));



    ////////////////////////////post male data api through ///////////////////////////////


    const submitMaleData = async () => {

        if (isSubmitting) return;

        setIsSubmitting(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) return;

            if (!maleForm.CRN_No) {
                // alert("Please enter CRN No before saving Male details");

                setErrorMsg("Please enter CRN No before saving Male details");
                // setErrorMsg("");

                setTimeout(() => setErrorMsg(""), 1000);


                return;
            }

            const filteredHormonalRows = maleHormonalRows.filter(
                r =>
                    r.assay_date ||
                    r.FSH ||
                    r.LH ||
                    r.Testosterone ||
                    r.Prolactin ||
                    r.TSH
            );

            const payload = {
                male: maleForm, // ✅ CORRECT
                hormonal_assay: filteredHormonalRows
            };

            const response = await axios.post(
                `${API_URL}/add_male_partner_details`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            // alert(response.data.message);
            setSuccessMsg(response.data.message || "save male data successfully");
            setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);

            setMaleSaved(true);
            setActiveTab("female"); // move to female tab

        } catch (error) {
            console.error(error);
            // alert("Failed to save male data");

            setErrorMsg("Failed to save male data");

            setTimeout(() => setErrorMsg(""), 1000);
        }
        finally {
            setIsSubmitting(false);

        }
    };



    const submitFemaleData = async (e) => {
        e.preventDefault();

        if (isSubmittingFemale) return;

        setIsSubmittingFemale(true);
        if (!maleSaved || !maleForm.CRN_No) {
            // alert("Please complete Male details first before submitting Female details");


            setErrorMsg("Please complete Male details first before submitting Female details");
            setTimeout(() => setErrorMsg(""), 1000);

            return;
        }
        try {
            const token = localStorage.getItem("token");
            if (!token) return;



            const filteredHormonalRows = femaleHormonalRows.filter(
                r =>
                    r.assay_date ||
                    r.TSH ||
                    r.Prolactin ||
                    r.FSH ||
                    r.LH
            );

            const payload = {
                female: femaleForm, // ✅ CORRECT
                hormonal_assay: filteredHormonalRows
            };

            const response = await axios.post(
                `${API_URL}/add_female_partner_details`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            // alert(response.data.message);
            // navigate("/Patient_report_sample_id_wise");

            setSuccessMsg(response.data.message || "female data add successfully");
            setErrorMsg("");

            setTimeout(() => {
                navigate("/Patient_report_sample_id_wise");
            }, 1000);

        } catch (error) {
            console.error("Female submit error:", error);
            // alert("Failed to save female data");

            setErrorMsg("Failed to save female data");

            setTimeout(() => setErrorMsg(""), 1000);
        } finally {
            setIsSubmittingFemale(false);

        }
    };
    useEffect(() => {
        if (maleForm.center_code) {
            check_serial_number(maleForm.center_code);
        }
    }, [maleForm.center_code, maleForm.procedure]);

    return (
        <div>
            <h4><b>Sample Code</b></h4>
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            <Row className="mb-3" style={{ backgroundColor: "#e6e6e6" }}>
                <Col md={2}>
                    <Form.Label style={{ fontSize: "12px" }}>Center</Form.Label>

                    {loggedUser?.role === "1" ? (
                        <Form.Select
                            className="mb-3 no-select-icon"
                            name="center_code"
                            value={maleForm.center_code}
                            style={{ fontSize: "12px" }}
                            onChange={(e) => {
                                handleMaleChange(e);

                            }}
                        >
                            <option value="" disabled>Center</option>
                            {center_list.map((center) => (
                                <option
                                    key={`${center.id}-${center.center_code}`}
                                    value={`${center.center_code}/PIWIL`}
                                >
                                    {center.center_code}
                                </option>
                            ))}
                        </Form.Select>
                    ) : (
                        <Form.Control
                            className="mb-3"
                            name="center_code"
                            value={maleForm.center_code}
                            style={{ fontSize: "12px" }}

                            readOnly
                        />
                    )}
                </Col>
                <Col md={2}>
                    <Form.Label style={{ fontSize: "12px" }}>Procedure</Form.Label>
                    <Form.Select
                        name="procedure" className="mb-3 no-select-icon"
                        value={maleForm.procedure}
                        onChange={(e) => {
                            handleMaleChange(e);
                            if (maleForm.center_code) {
                                check_serial_number(maleForm.center_code);
                            }
                        }} style={{ fontSize: "12px" }}
                    >
                        <option value="" disabled>Procedure</option>
                        <option value="IUI">IUI</option>
                        <option value="IVF">IVF</option>
                        <option value="ICSI">ICSI</option>
                    </Form.Select>
                </Col>

                <Col md={1}>
                    <Form.Label style={{ fontSize: "12px" }}>Cycle</Form.Label>
                    <Form.Select
                        name="cycle"
                        value={maleForm.cycle} className="mb-3 no-select-icon"
                        onChange={(e) => handleMaleChange(e)} style={{ fontSize: "12px" }}
                    >
                        <option value="" disabled>Cycle</option>
                        {romanNumbers.map((r, index) => (
                            <option key={index} value={r}>{r}</option>
                        ))}
                    </Form.Select>
                </Col>

                <Col md={1}>
                    <Form.Label style={{ fontSize: "12px" }}>Donor</Form.Label>
                    <Form.Select
                        name="donor_sperm"
                        value={maleForm.donor_sperm} className="mb-3 no-select-icon" style={{ fontSize: "12px" }}
                        onChange={(e) => handleMaleChange(e)}
                    >
                        <option value="" disabled>Donor</option>
                        <option value="D">Yes</option>
                        <option value="N">No</option>
                    </Form.Select>
                </Col>

                <Col md={2}>
                    <Form.Label style={{ fontSize: "12px" }}>Serial No</Form.Label>
                    <Form.Control
                        type="text"
                        name="serial_no"
                        value={maleForm.serial_no} className="mb-3" placeholder="enter serial no."
                        onChange={(e) => handleMaleChange(e)} style={{ fontSize: "12px" }}
                    />
                </Col>


                <Col md={3}>
                    <Form.Label style={{ fontSize: "12px" }}>Generated Sample ID</Form.Label>
                    <Form.Control
                        name="sample_generated"
                        value={maleForm.sample_generated}
                        readOnly
                        style={{
                            height: "30px",
                            fontSize: "13px",
                            paddingTop: "6px",
                            paddingBottom: "0px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            backgroundColor: "hsla(120, 24%, 89%, 1.00)"

                        }}
                    />

                </Col>
                <Col md={1} className="d-flex align-items-end mb-3">
                    <Button
                        type="button"
                        className="w-100"
                        onClick={validateBeforeMove}
                        disabled={!maleForm.sample_generated}
                        style={{
                            height: "28px",
                            fontSize: "12px",
                            padding: "0 10px",
                            lineHeight: "1",
                        }}
                    >
                        Validate
                    </Button>
                </Col>



            </Row>
            <div
                className="position-relative mb-1 px-1 py-0 bg-light border rounded"
                style={{ minHeight: "22px" }}
            >
                {/* LEFT: Checkbox */}
                <div className="d-flex align-items-center">
                    <Form.Check className="d-flex align-items-center mb-0">
                        <Form.Check.Input
                            type="checkbox"
                            checked={sampleValid}
                            onChange={validateBeforeMove}
                            required
                            disabled={!maleForm.sample_generated}
                            style={{
                                width: "14px",
                                height: "14px",
                                border: "1.5px solid #805555",
                                marginTop: "0px",
                                cursor: maleForm.sample_generated ? "pointer" : "not-allowed",
                            }}
                        />
                        <Form.Check.Label
                            className="ms-1 fw-semibold"
                            style={{
                                fontSize: "12px",
                                lineHeight: "1",
                            }}
                        >
                            Sample ID valid
                        </Form.Check.Label>
                    </Form.Check>
                </div>

                {/* CENTER: Message */}
                {(sampleError || sampleValid) && (
                    <div
                        className="position-absolute top-50 start-50 translate-middle fw-semibold"
                        style={{
                            fontSize: "12px",
                            lineHeight: "1",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {sampleError && (
                            <span className="text-danger">❌ {sampleError}</span>
                        )}

                        {sampleValid && !sampleError && (
                            <span className="text-success">✅ Sample ID is valid</span>
                        )}
                    </div>
                )}
            </div>









            <h4><b>Partner Details</b></h4>

            <Tabs activeKey={activeTab}
                onSelect={(k) => {
                    if (k === "female" && !maleSaved) {
                        // alert("⚠ Please fill and save Male details first (CRN No required)");

                        setErrorMsg("⚠ Please fill and save Male details first (CRN No required)");

                        setTimeout(() => setErrorMsg(""), 1000);
                        return;
                    }
                    setActiveTab(k);
                }}
                className="mb-3" >
                <Tab eventKey="male" title="Male">

                    <MaleForm form={maleForm} handleFormChange={handleMaleChange} onSubmit={submitMaleData} rows={maleHormonalRows}
                        setRows={setMaleHormonalRows} crnDisabled={crnDisabled} onDobChange={handleMaleDobChange} handleMaleAgeChange={handleMaleAgeChange} isSubmitting={isSubmitting} />
                </Tab>

                <Tab eventKey="female" title="Female">

                    <Female_Details form={femaleForm} handleFormChange={handleFemaleChange} rows={femaleHormonalRows}
                        setRows={setFemaleHormonalRows} onSubmit={submitFemaleData} onDobChange={handleFemaleDobChange} disabled={!maleSaved} handleFemaleAgeChange={handleFemaleAgeChange} isSubmitting={isSubmittingFemale} />
                </Tab>

                {/* <Tab eventKey="male" title="Male">

                    <MaleForm form={maleForm} handleFormChange={handleMaleChange} onSubmit={submitMaleData} rows={maleHormonalRows}
                        setRows={setMaleHormonalRows} crnDisabled={crnDisabled} onDobChange={handleMaleDobChange} onCalculate={handleMaleCalculationChange} onMotile_total={handleProgressiveMotileSperm} total_motility={handleMotility} handleMaleAgeChange={handleMaleAgeChange} isSubmitting={isSubmitting} />
                </Tab>

                <Tab eventKey="female" title="Female">

                    <Female_Details form={femaleForm} handleFormChange={handleFemaleChange} rows={femaleHormonalRows}
                        setRows={setFemaleHormonalRows} onSubmit={submitFemaleData} onDobChange={handleFemaleDobChange} disabled={!maleSaved} handleFemaleAgeChange={handleFemaleAgeChange} isSubmitting={isSubmittingFemale} />
                </Tab> */}

            </Tabs>

            <style>{`
       

                    /* Remove select arrow */
                    .no-select-icon {
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    background-image: none !important;
                    }       
                    }.unit-input .form-control {
    border-right: 0;
}

.unit-input .unit-text {
    background-color: #fff;
    border-left: 1px solid #ced4da;
    font-weight: 500;
    min-width: 80px;
    justify-content: center;
}



/* When a real value is selected */

/* Disabled option styling */
.form-select:valid {
  color: #000;
}
  .form-select option[disabled] {
  color: #9aa0a6;
}





.floating-btn {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background-color: #0d6efd;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 14px 22px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    z-index: 9999;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);
}

.floating-btn:hover {
    background-color: #084298;
}



.percent-text {
  color: red;
}
     
     `}</style>
        </div>


    );
}

export default Male_Details;
